import React, { ReactElement } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { DateDisplay } from "../DateDisplay";
import { InvoiceHistoryEntry } from "../../models/Invoice";
import { Typography } from "@material-ui/core";
import colors from "../../constants/colors";
import { InvoiceViewHistoryDialog } from "./InvoiceViewHistoryDialog";

interface InvoiceFileSetNoteSectionProps {
	//The list of invoice history entries to display.
	historyList: InvoiceHistoryEntry[];
	//The callback method for settingthe dialog contents for the page.
	setDialogContents: (title: string, element: ReactElement | undefined) => void;
}

const useStyles = makeStyles((theme) => ({
	button: {
		marginLeft: theme.spacing(2),
		marginTop: 5,
		marginBottom: 5,
		float: "right",
		width: 120,
	},
	historyListEntry: {
		textOverflow: "elipsis",
		borderTop: "1px solid gray",
		whitespace: "nowrap",
		overflow: "hidden",
		display: "flex",
	},
	topHistoryListEntry: {
		textOverflow: "elipsis",
		overflow: "hidden",
		whitespace: "nowrap",
		display: "flex",
	},
	historyListEntryText: {
		width: 400,
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
	},
}));

/**
 * this component displays the last 3 invoice history entries and allows for the user to display a dialog with the rest of the hisotry entries.
 * @param props
 */
export const InvoiceFileSetHistorySection = (props: InvoiceFileSetNoteSectionProps) => {
	const classes = useStyles();
	return (
		<div style={{ marginLeft: 10 }}>
			<Typography style={{ marginRight: 5, marginBottom: 10, marginTop: 10, fontWeight: "bold" }}>History</Typography>
			<div style={{ display: "flex" }}>
				<div
					style={{
						backgroundColor: colors.gray100,
						paddingLeft: 5,
						paddingRight: 5,
						paddingTop: 2,
						maxWidth: 600,
						overflow: "auto",
						border: "1px solid",
						borderColor: colors.gray300,
						boxShadow: "-1px 1px 1px gray",
						borderRadius: 5,
					}}
					data-testid={"invoice-set-history-list"}
				>
					<div style={{ margin: "auto" }}>
						{props.historyList.length > 0 && (
							<div style={{ marginTop: props.historyList.length > 1 ? 0 : 5 }} className={classes.topHistoryListEntry}>
								<div className={classes.historyListEntryText}>
									<Typography>{props.historyList[0].note}</Typography>
								</div>
								<div style={{ marginLeft: 50 }}>
									<DateDisplay fontSize={15} date={props.historyList[0].date}></DateDisplay>
								</div>
							</div>
						)}
						{props.historyList.length > 1 && (
							<div className={classes.historyListEntry}>
								<div className={classes.historyListEntryText}>
									<Typography>{props.historyList[1].note}</Typography>
								</div>
								<div style={{ marginLeft: 50 }}>
									<DateDisplay fontSize={15} date={props.historyList[1].date}></DateDisplay>
								</div>
							</div>
						)}
						{props.historyList.length > 2 && (
							<div className={classes.historyListEntry}>
								<div className={classes.historyListEntryText}>
									<Typography>{props.historyList[2].note}</Typography>
								</div>
								<div style={{ marginLeft: 50 }}>
									<DateDisplay fontSize={15} date={props.historyList[2].date}></DateDisplay>
								</div>
							</div>
						)}
					</div>
				</div>
				<div
					style={{
						height: 40,
						margin: "auto",
						marginLeft: 86,
						whiteSpace: "nowrap",
						justifySelf: "flex-end",
					}}
				>
					<Button
						size="small"
						variant="outlined"
						color={"primary"}
						onClick={() => {
							props.setDialogContents(
								"Invoice History",
								<InvoiceViewHistoryDialog historyList={props.historyList}></InvoiceViewHistoryDialog>,
							);
						}}
						className={classes.button}
						data-testid="view-history-button"
					>
						{"View History"}
					</Button>
				</div>
			</div>
		</div>
	);
};
